<div class="row space-between">
  <h2>Add new Stream</h2>
  <div class="btnrow row gap-8 align-center">
    <rr-btn size="Small" type="Link">Download as CSV</rr-btn>
    <rr-btn size="Small" iconStart="upload" type="Secondary">Upload CSV</rr-btn>
  </div>
</div>
<div class="configarea"></div>
